/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PostFaceToFaceKycIdentityDocumentRequest
 */
export interface PostFaceToFaceKycIdentityDocumentRequest {
    /**
     * Identity document file
     * @type {File}
     * @memberof PostFaceToFaceKycIdentityDocumentRequest
     */
    'file': File;
    /**
     * Type of personal identification document
     * @type {string}
     * @memberof PostFaceToFaceKycIdentityDocumentRequest
     */
    'personalDocumentType'?: PostFaceToFaceKycIdentityDocumentRequestPersonalDocumentTypeEnum;
    /**
     * Name of the person who verified the document
     * @type {string}
     * @memberof PostFaceToFaceKycIdentityDocumentRequest
     */
    'verifiedBy'?: string;
}

export const PostFaceToFaceKycIdentityDocumentRequestPersonalDocumentTypeEnum = {
    passport: 'PASSPORT',
    individualNumberCard: 'INDIVIDUAL_NUMBER_CARD',
    driversLicenseFront: 'DRIVERS_LICENSE_FRONT',
    driversLicenseBack: 'DRIVERS_LICENSE_BACK'
} as const;

export type PostFaceToFaceKycIdentityDocumentRequestPersonalDocumentTypeEnum = typeof PostFaceToFaceKycIdentityDocumentRequestPersonalDocumentTypeEnum[keyof typeof PostFaceToFaceKycIdentityDocumentRequestPersonalDocumentTypeEnum];


